import { useState } from "react";
import { Button } from "components/common/Button";
import RadioControl from "components/common/RadioControl/RadioControl";
import styles from "./index.module.scss";
import classNames from "classnames";
import ToolbarControl from "components/common/Toolbar/ToolbarControl";
import { ReactComponent as IconClose } from "components/icons/close.svg";
import RadixSelect from "components/common/RadixSelect";
import commonStyles from "styles/common.module.scss";
import mapData from "lib/stores/mapData";
import apiData from "lib/stores/apiData";
import { useSnapshot } from "valtio";

const ProductsControlBar = () => {
  const { selectedProduct, productsCountry, activeCategory } = useSnapshot(mapData, { sync: true });
  const { countries, products } = useSnapshot(apiData, { sync: true });

  const onClickRadioControl = (value: string) => {
    if (selectedProduct === value) mapData.selectedProduct = null;
  };

  const changeHandler = (value: string) => {
    mapData.selectedProduct = value;
  };

  const renderButtonsComponent = () => {
    const country = countries[productsCountry];
    let imports = new Set();
    try {
      country.imports.forEach(imp => {
        const product = {
          name: imp.product,
          value: imp.product.toLowerCase()
        };
        imports.add(JSON.stringify(product));
      });
    } catch (e) {}

    imports = Array.from(imports).map(imp => {
      const product = JSON.parse(imp);
      product.icon = getIconForProduct(product.value);
      product.value = product.value.replaceAll(' ', '%20');
      return product;
    });

    imports = Array.from(imports).sort((a, b) => {
      let aTotal = 0;
      let bTotal = 0;
      country.imports.forEach(imp => {
        if (imp.product === a.name) {
          aTotal += imp.value;
        }
        if (imp.product === b.name) {
          bTotal += imp.value;
        }
      });
      if (aTotal > bTotal) return -1;
      if (aTotal < bTotal) return 1;
      return 0;
    });

    return (
      <RadioControl
        className={`product-radio-${activeCategory} no-drag`}
        label="Products"
        value={selectedProduct}
        onChange={changeHandler}
        onClick={onClickRadioControl}
        options={imports}
      />
    );
  };

  const getProductsObjects = () => {
    const country = countries[productsCountry];
    let imports = new Set();
    try {
      country.imports.forEach(imp => {
        const product = {
          name: imp.product,
          value: imp.product.toLowerCase()
        };
        imports.add(JSON.stringify(product));
      });
    } catch (e) {}

    imports = Array.from(imports).map(imp => {
      const product = JSON.parse(imp);
      product.icon = getIconForProduct(product.value);
      return { label: product.name, value: product.value };
    });
    return imports;
  };

  const getIconForProduct = product => {
    return (
      <div className={commonStyles["product-svg"]}>
        <img alt="" src={products.get(product).icon} />
      </div>
    );
  };

  const onClick = () => {
    mapData.selectedProduct = null;
  };

  const getClassForActiveCategory = () => {
    switch (activeCategory) {
      case "prevalence":
        return styles["desktop-product-selector-prevalence"];
      case "vulnerability":
        return styles["desktop-product-selector-vulnerability"];
      case "gov-response":
        return styles["desktop-product-selector-gov-response"];
    }
  };
  if (!productsCountry) return null;
  return (
    <>
      <div className={styles["imports-control-bar"]}>
        {/* Product Selector */}
        <ToolbarControl
          className={classNames(styles.toolbarControl, styles["desktop-product-selector"], getClassForActiveCategory())}
          label="Choose a product"
        >
          {renderButtonsComponent()}
        </ToolbarControl>
        <ToolbarControl label="Choose a product" className={classNames(styles["radix-select-desktop-map-controls-wrapper"])}>
          <RadixSelect
            onValueChange={product => {
              mapData.selectedProduct = product;
            }}
            value={selectedProduct}
            placeholder={selectedProduct ? selectedProduct.charAt(0).toUpperCase() + selectedProduct.slice(1).replace(/%20/g, ' ') : "Choose a Product"}
            selectContentClassName="-translate-x-[2px] max-h-[800px] md:w-64 lg:w-48 xl:w-64"
            triggerClassName={classNames(styles["radix-select-desktop-map-controls"], "border-[1px] border-black ")}
            groups={[
              {
                label: "Choose A Product",
                items: [...getProductsObjects()]
              }
            ]}
          />
        </ToolbarControl>

        {/* Clear Selection Button */}
        {productsCountry && selectedProduct && (
          <ToolbarControl className={styles["clear-selection-button"]} contentsClassName={styles.contents}>
            <Button icon={<IconClose />} onClick={onClick} variant="secondary">
              Clear
            </Button>
          </ToolbarControl>
        )}
      </div>
    </>
  );
};

export default ProductsControlBar;
